import type { ErrorEvent } from '@sentry/nextjs';

/**
 * Sentry 이슈 PLAY-APP top 100 기준 SignalR 연결 실패가 12만+ 이벤트를 생성.
 * chunk hash가 빌드마다 달라지면 동일한 근본 원인도 별도 이슈로 분리되므로
 * 고정 fingerprint로 단일 그룹에 수렴시킨다.
 *
 * 감지 기준: 에러 메시지에 SignalR 연결 실패 패턴 포함.
 * 프레임 기반 탐지는 패킷 핸들러 내 실제 버그를 연결 실패로 오분류할 위험이 있어 제외.
 */
const SIGNALR_MESSAGE_PATTERNS = [
  'Failed to complete negotiation with the server',
  'Failed to start the connection',
  'WebSocket failed to connect',
  'Server returned an error on close',
  'The connection was stopped',
];

function isSignalRError(event: ErrorEvent): boolean {
  const message = event.exception?.values?.[0]?.value ?? event.message ?? '';
  return SIGNALR_MESSAGE_PATTERNS.some(p => message.includes(p));
}

export function applySignalRFingerprint(event: ErrorEvent): void {
  // beforeSend에서 throw 발생 시 Sentry SDK가 해당 이벤트를 드롭하므로,
  // fingerprint 적용 실패가 원본 에러 보고를 막지 않도록 안전망을 둔다.
  try {
    if (!isSignalRError(event)) return;

    event.fingerprint = ['signalr-connection-failure'];

    if (!event.tags) event.tags = {};
    event.tags['signalr_error'] = 'true';
  } catch {
    // ignore: fingerprint 그룹핑은 부가 기능, 실패해도 원본 이벤트는 보존
  }
}
